import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
} from "@chakra-ui/react";
import SidebarContent from "./SidebarContent";
import MobileNav from "./MobileNav";
import { linkItems } from "../../utils/linkItems";

const Sidebar = ({ children }) => {
  const { pathname } = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const authLayout = useMemo(() => {
    const mainPath = linkItems.map((item) => item.href);
    const validasi = [...mainPath, "/profile"].indexOf(pathname);

    if (validasi === -1) {
      return true;
    }

    return false;
  }, [pathname]);
  return (
    <Box minH="100vh" bg={useColorModeValue("gray.50", "blackAlpha.700")}>
      {authLayout ? (
        <Box p="4" minH="100vh">{children}</Box>
      ) : (
        <>
          <SidebarContent
            onClose={() => onClose}
            display={{ base: "none", md: "block" }}
          />
          <Drawer
            autoFocus={false}
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            returnFocusOnClose={false}
            onOverlayClick={onClose}
            size="full"
          >
            <DrawerContent>
              <SidebarContent onClose={onClose} />
            </DrawerContent>
          </Drawer>
          {/* mobilenav */}
          <MobileNav onOpen={onOpen} />
          <Box ml={{ base: 0, md: "260px" }} p="4" pt={{ base: "24", md: "4" }}>
            {children}
          </Box>
        </>
      )}
    </Box>
  );
};

export default Sidebar;
